import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import LeadService from "../../services/LeadService";    

interface APIResponse {
    data: {
        status: number,
        message: string,
        data?: any
    }
}

const Lead = createSlice({
    name: 'lead',
    initialState: {
        leadList: {},
    },
    reducers: {
        leadList: (state, action) => {
            state.leadList = action.payload
        }
    }
})

export default Lead.reducer;

const { leadList } = Lead.actions


/**
 * Function to make API call to fetch Reconciliation listing
 * @param params 
 * @returns 
 */
export const getLeadList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {        
        LeadService.getLeadListing(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                        dispatch(leadList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getLeadDetail = (params: object) => {
    return new Promise((resolve, reject) => {
        LeadService.getLeadDeatil(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const leadApproveReject = (params: object) => {
    return new Promise((resolve, reject) => {
        LeadService.leadApproveReject(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getDashboardCount = () => {
    return new Promise((resolve, reject) => {
        LeadService.getDashboardCount()
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const leadDocumentResubmit = (params: object) => {
    return new Promise((resolve, reject) => {
        LeadService.leadDocumentResubmit(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}






